const SET_LIST = (state, payload) => {
  state.list = payload
}

const SET_ERRORS_DOCS = (state, payload) => {
  state.errors.docs = payload
}

const RESET_ERRORS = (state) => {
  state.errors = { ...state.initialErrors }
}

const RESET_ERRORS_DOCS = (state) => {
  state.errors.docs = []
}

export default {
  RESET_ERRORS,
  SET_ERRORS_DOCS,
  RESET_ERRORS_DOCS,
  SET_LIST
}



// WEBPACK FOOTER //
// ./src/features/manager_invoices/store/mutations.js